import { useScrollAnimation, useStaggerAnimation } from '@/hooks/useScrollAnimation';

const clients = [
  {
    jp: '医療・福祉',
    en: 'Healthcare & Welfare',
    quote: '「患者に選ばれる理由」を、言葉にしたい。',
    desc: '病院、クリニック、介護・障害福祉事業者。社会的使命を持ちながら、発信力に課題を感じている組織。',
  },
  {
    jp: '教育',
    en: 'Education',
    quote: '「うちの学校の良さ」を、伝えられていない。',
    desc: '私立学校、大学、教育NPO、社会教育施設。理念と実践の間にある「言葉の空白」を埋めたい組織。',
  },
  {
    jp: '地域・文化',
    en: 'Community & Culture',
    quote: '「この地域の価値」を、外に届けたい。',
    desc: '地域振興団体、文化施設、アートプロジェクト、まちづくり組織。地域固有の意味を可視化したい組織。',
  },
  {
    jp: '行政・公共',
    en: 'Public Sector',
    quote: '「市民との関係」を、もう一度つくり直したい。',
    desc: '自治体、公益財団法人、独立行政法人。市民・社会との新たな信頼関係を構築したい組織。',
  },
];

export default function ClientsSection() {
  const heading = useScrollAnimation();
  const rows = useStaggerAnimation(clients.length);

  return (
    <section className="py-28 md:py-40 bg-warm-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Heading */}
        <div
          ref={heading.ref as React.RefObject<HTMLDivElement>}
          className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-20 transition-all duration-700"
          style={{ opacity: heading.isVisible ? 1 : 0, transform: heading.isVisible ? 'translateY(0)' : 'translateY(28px)' }}
        >
          <div className="md:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <span className="block w-6 h-px bg-accent-teal" />
              <span className="text-[10px] font-sans-jp text-accent-teal tracking-widest-jp uppercase">Suitable Clients</span>
            </div>
            <h2 className="font-serif-jp font-light text-charcoal tracking-normal-jp leading-snug text-2xl md:text-3xl">
              こんな言葉が頭にある方と、<br />仕事をしています。
            </h2>
          </div>
        </div>

        {/* Rows */}
        <div
          ref={rows.ref as React.RefObject<HTMLDivElement>}
          className="space-y-0 border-t border-divider"
        >
          {clients.map((c, i) => (
            <div
              key={c.jp}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-12 border-b border-divider items-start transition-all duration-700"
              style={{
                opacity: rows.visibleCount > i ? 1 : 0,
                transform: rows.visibleCount > i ? 'translateY(0)' : 'translateY(24px)',
                transitionDelay: `${i * 100}ms`,
              }}
            >
              <div className="md:col-span-2">
                <span className="font-serif-jp text-base font-light text-charcoal tracking-normal-jp block">{c.jp}</span>
                <span className="font-garamond text-xs italic text-muted-light mt-1 block">{c.en}</span>
              </div>
              <div className="md:col-span-4">
                <p className="font-serif-jp font-light text-charcoal tracking-normal-jp leading-snug text-lg">{c.quote}</p>
              </div>
              <div className="md:col-span-6">
                <p className="font-sans-jp text-sm text-muted-brown leading-relaxed-jp">{c.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
